// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"68a377461e0bd263","7854":"179603e0177f1512"}[chunkId] + ".css";
};